import React, { useEffect, useContext, useRef, use } from 'react';
import { Grid, Box } from '@mui/material';
import Vendors from './VendorsKiosk/Vendors';
import { useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import { AppContext } from '../../context/Context';
import TransactionList from './TransactionList';

import { SocketContext } from '../../context/SocketContext';
import { SocketNFCContext } from '../../context/SocketNFC';

import ModalSellKiosk from './Modals/ModalSellKiosk';
import ModalSellPapir from './Modals/ModalSellPapir';
import ModalSellPapirKingo from './Modals/ModalSellPapirKingo';
import ModalSellPapirXtipp from './Modals/ModalSellPapirXtipp';
import ModalConfirmationLogout from './Modals/ModalConfirmationLogout';
import ModalPayment from './Modals/ModalPayment';
import ModalBlockedToBuyDataBingo from './Modals/ModalBlockedToBuyDataBingo';
import ModalLimitSurpassed from './Modals/ModalLimitSurpassed';
import ModalPaperOutKiosk from './Modals/ModalPaperOutKiosk';
import { useTranslation } from 'react-i18next';

function SalgsKiosk() {
  const { t, i18n } = useTranslation();

  const {
    isLoginRefill,
    updateVendorInfo,
    updateSellType,
    updateShowModalSellKiosk,
    updateIsLoadingScreen,
    updatePapirScannedInfo,
    updateShowModalPapirGameBatchResult,
    updateShowModalPapirGameNotFinished,
    updateShowModalPapirGameFinishedWithoutPrize,
    updateShowModalPapirGameFinishedWithPrize,
    updatePapirPrize,

    isShiftOpen,
    isBlocking,
    BlockingScreen,
    userInfo,
    parentInfo,
    hall,
    showModalSellKiosk,
    showModalConfirmLogout,
    isLogin,
    showModalSellPapir,
    showModalSellPapirKingo,
    showModalSellPapirXtipp,
    showModalPaymentKiosk,
    showModalBlockedToBuyDataBingo,
    showModalLimitSurpassedKiosk,
    kioskHall,
    printerIP,
    showModalPaperOutKiosk,
    updateShowModalPaperOutKiosk,
  } = useContext(AppContext);

  const navigate = useNavigate();

  useEffect(() => {
    const hallToUse = !hall || hall === '' ? 'Roulingo' : hall; // hall viene del contexto

    if (!isLogin) {
      navigate(`/login-kiosk?hall=${encodeURIComponent(hallToUse)}`, {
        replace: true,
      });
    }
  }, []);

  useEffect(() => {
    if (!isLoginRefill) {
      return;
    }

    switch (isLoginRefill) {
      case 'ch':
        updateVendorInfo({
          name: 'Clubhouse Spill',
          options: [
            {
              option: 'Ny Billett',
              color: '#009e82',
              type: 3,
            },
            {
              option: 'Utbetaling',
              color: '#fc86c1',
              type: 5,
            },
            {
              option: 'Fylle på',
              color: '#fcad89',
              type: 6,
            },
          ],
        });
        updateSellType(6);
        updateShowModalSellKiosk(true);
        break;
      case 'wg':
        updateVendorInfo({
          name: 'WinGames',
          options: [
            { option: t('sales.newTicket'), color: '#009e82', type: 4 },
            { option: t('sales.payout'), color: '#fc86c1', type: 5 },
            { option: t('sales.refill'), color: '#fcad89', type: 6 },
            { option: t('sales.scan'), color: '#8a9dad', type: 8 },
          ],
        });
        updateSellType(6);
        updateShowModalSellKiosk(true);
        break;
      case 'okd':
        updateVendorInfo({
          name: 'OK Databingo',
          options: [
            { option: t('sales.newTicket'), color: '#009e82', type: 4 },
            { option: t('sales.payout'), color: '#fc86c1', type: 5 },
            { option: t('sales.refill'), color: '#fcad89', type: 6 },
            { option: t('sales.scan'), color: '#8a9dad', type: 8 },
          ],
        });
        updateSellType(6);
        updateShowModalSellKiosk(true);
        break;
    }
  }, [isLoginRefill]);

  const { socket } = useContext(SocketContext);
  const socketNFC = useContext(SocketNFCContext);

  const showModalSellKioskRef = useRef(showModalSellKiosk);
  useEffect(() => {
    showModalSellKioskRef.current = showModalSellKiosk;
  }, [showModalSellKiosk]);

  const kioskHallRef = useRef(kioskHall);
  useEffect(() => {
    kioskHallRef.current = kioskHall;
  }, [kioskHall]);

  const printerIPRef = useRef(printerIP);
  useEffect(() => {
    printerIPRef.current = printerIP;
  }, [printerIP]);

  useEffect(() => {}, [socket]);

  useEffect(() => {
    if (window.location.hostname === 'localhost') return;
    if (!kioskHall) return;

    socket.emit('checkPaperStatus', {
      bingoName: kioskHallRef.current,
      printerIP: printerIPRef.current,
    });

    const interval = setInterval(() => {
      socket.emit('checkPaperStatus', {
        bingoName: kioskHallRef.current,
        printerIP: printerIPRef.current,
      });
    }, 30000);

    return () => clearInterval(interval);
  }, [kioskHall, socket]);

  useEffect(() => {
    if (!userInfo || !userInfo.username || userInfo.username === 'Gjest') {
      return;
    }
    socket.emit('checkLimitStatus', {
      userInfo: parentInfo ? parentInfo : userInfo,
      bingoName: hall,
    });
  }, [userInfo, hall]);

  useEffect(() => {
    const handleCheckPapirBatch = (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      updatePapirScannedInfo(data);
      updateShowModalPapirGameBatchResult(true);
    };

    const handleCheckPapirKingoBatch = (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      updatePapirScannedInfo(data);
      updateShowModalPapirGameBatchResult(true);
    };

    const handleCheckPapirCard = (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }

      if (!data.isGameFinished) {
        updatePapirScannedInfo(data);
        updateShowModalPapirGameNotFinished(true);
        return;
      }

      if (data.isGameFinished && !data.hasTicketPrize) {
        updatePapirScannedInfo(data);
        updateShowModalPapirGameFinishedWithoutPrize(true);
        return;
      }

      if (data.isGameFinished && data.hasTicketPrize) {
        updatePapirPrize('pw');
        updatePapirScannedInfo(data);
        updateShowModalPapirGameFinishedWithPrize(true);
        return;
      }

      return;
    };

    const handleCheckPapirKingoCard = (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }

      if (!data.isGameFinished) {
        updatePapirScannedInfo(data);
        updateShowModalPapirGameNotFinished(true);
        return;
      }

      if (data.isGameFinished && !data.hasTicketPrize) {
        updatePapirScannedInfo(data);
        updateShowModalPapirGameFinishedWithoutPrize(true);
        return;
      }

      if (data.isGameFinished && data.hasTicketPrize) {
        updatePapirPrize('kingo');
        updatePapirScannedInfo(data);
        updateShowModalPapirGameFinishedWithPrize(true);
        return;
      }

      return;
    };

    const handleCheckPapirXtippBatch = (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      updatePapirScannedInfo(data);
      updateShowModalPapirGameBatchResult(true);
    };

    const handleCheckPapirXtippCard = (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }

      if (!data.isGameFinished) {
        updatePapirScannedInfo(data);
        updateShowModalPapirGameNotFinished(true);
        return;
      }

      if (data.isGameFinished && !data.hasTicketPrize) {
        updatePapirScannedInfo(data);
        updateShowModalPapirGameFinishedWithoutPrize(true);
        return;
      }

      if (data.isGameFinished && data.hasTicketPrize) {
        updatePapirPrize('xtipp');
        updatePapirScannedInfo(data);
        updateShowModalPapirGameFinishedWithPrize(true);
        return;
      }

      return;
    };

    const handleCheckPaperStatus = (data) => {
      if (!data) return;
      if (data.status === 'unknown') {
        updateShowModalPaperOutKiosk('unknown');
      } else if (data.paperEnd) {
        updateShowModalPaperOutKiosk('paperEnd');
      } else if (data.nearEnd) {
        updateShowModalPaperOutKiosk('nearEnd');
      } else {
        updateShowModalPaperOutKiosk(null);
      }
    };

    socket.on('checkPapirCard', handleCheckPapirCard);
    socket.on('checkPapirBatch', handleCheckPapirBatch);
    socket.on('checkPapirKingoCard', handleCheckPapirKingoCard);
    socket.on('checkPapirXtippCard', handleCheckPapirXtippCard);
    socket.on('checkPapirKingoBatch', handleCheckPapirKingoBatch);
    socket.on('checkPapirXtippBatch', handleCheckPapirXtippBatch);
    socket.on('checkPaperStatus', handleCheckPaperStatus);

    return () => {
      socket.off('checkPapirCard', handleCheckPapirCard);
      socket.off('checkPapirBatch', handleCheckPapirBatch);
      socket.off('checkPapirKingoCard', handleCheckPapirKingoCard);
      socket.off('checkPapirXtippCard', handleCheckPapirXtippCard);
      socket.off('checkPapirKingoBatch', handleCheckPapirKingoBatch);
      socket.off('checkPapirXtippBatch', handleCheckPapirXtippBatch);
      socket.off('checkPaperStatus', handleCheckPaperStatus);
    };
  }, [socket]);

  useEffect(() => {
    const handleScannedXtippPapir = (data) => {
      updateIsLoadingScreen(true);

      const bingoName = kioskHallRef.current;
      const parts = data.split('|'); // ["PXT", ...]
      // Guard against bad scans
      if (parts.length < 3) {
        toast.error(t('sales.invalidTicket'));
        updateIsLoadingScreen(false);
        return;
      }

      if (parts[1] === 'B') {
        // Batch
        const code = parts[2];

        socket.emit('checkPapirXtippBatch', {
          code,
          bingoName,
        });
      } else {
        // Single card
        const ticketID = parts[1];
        const gameID = parts[2] ?? '';

        socket.emit('checkPapirXtippCard', {
          ticketID,
          bingoName,
          gameID,
        });
      }
    };

    const handleScannedKingoPapir = (data) => {
      //const bingoName = 'roulingo';
      const bingoName = kioskHallRef.current;
      const parts = data.split('|'); // ["PXT", ...]
      // Guard against bad scans
      if (parts.length < 3) {
        toast.error(t('sales.invalidTicket'));
        updateIsLoadingScreen(false);
        return;
      }

      if (parts[1] === 'B') {
        // Batch
        const code = parts[2];

        socket.emit('checkPapirKingoBatch', {
          code,
          bingoName,
        });
      } else {
        // Single card
        const ticketID = parts[1];
        const gameID = parts[2] ?? '';

        socket.emit('checkPapirKingoCard', {
          ticketID,
          bingoName,
          gameID,
        });
      }
    };

    const handleScannedPowerBingoPapir = (data) => {
      //const bingoName = 'roulingo';
      const bingoName = kioskHallRef.current;
      const parts = data.split('|'); // ["PXT", ...]
      // Guard against bad scans
      if (parts.length < 3) {
        toast.error(t('sales.invalidTicket'));
        updateIsLoadingScreen(false);
        return;
      }

      if (parts[1] === 'B') {
        // Batch
        const code = parts[2];

        socket.emit('checkPapirBatch', {
          code,
          bingoName,
        });
      } else {
        // Single card
        const ticketID = parts[1];
        const gameID = parts[2] ?? '';

        socket.emit('checkPapirCard', {
          ticketID,
          bingoName,
          gameID,
        });
      }
    };

    const handleScannedQR = (data) => {
      if (!data.includes('qr.clubhouse.no')) {
        toast.error(t('sales.invalidTicket'));
        updateIsLoadingScreen(false);
        return;
      }
      const urlMatch = data.match(/https?:\/\/[^\s]+/);
      if (!urlMatch) {
        toast.error(t('sales.invalidTicketUrl'));
        updateIsLoadingScreen(false);
        return;
      }

      const url = new URL(data); // Parse the URL
      const params = new URLSearchParams(url.search); // Extract the query string

      // Prepare the data to be sent based on the parameters
      const dataToSearch = {};

      if (params.has('c') && params.has('p') && params.has('bn')) {
        const c = params.get('c');
        const p = params.get('p');
        const bn = params.get('bn');
        const bingoName = bn.replace(/_/g, ' ');
        if (bingoName !== kioskHallRef.current) {
          toast.error(t('sales.papirBatchInvalidHall'));
          updateIsLoadingScreen(false);
          return;
        }

        if (p === 'pw') {
          const b = params.get('b');
          if (b === 'true') {
            socket.emit('checkPapirBatch', {
              code: c,
              provider: p,
              bingoName: bingoName,
            });
          } else {
            const g = params.get('g');

            socket.emit('checkPapirCard', {
              ticketID: c,
              bingoName: bingoName,
              gameID: g,
            });
          }
        }
        if (p === 'kingo') {
          const b = params.get('b');
          if (b === 'true') {
            socket.emit('checkPapirKingoBatch', {
              code: c,
              bingoName: bingoName,
            });
          } else {
            const g = params.get('g');

            socket.emit('checkPapirKingoCard', {
              ticketID: c,
              bingoName: bingoName,
              gameID: g,
            });
          }
        }
        if (p === 'xtipp') {
          const b = params.get('b');
          if (b === 'true') {
            socket.emit('checkPapirXtippBatch', {
              code: c,
              bingoName: bingoName,
            });
          } else {
            const g = params.get('g');

            socket.emit('checkPapirXtippCard', {
              ticketID: c,
              bingoName: bingoName,
              gameID: g,
            });
          }
        }

        return;
      }
    };

    socketNFC.on('scannedXtippPapir', handleScannedXtippPapir);
    socketNFC.on('scannedKingoPapir', handleScannedKingoPapir);
    socketNFC.on('scannedPapir', handleScannedPowerBingoPapir);
    socketNFC.on('scannedQR', handleScannedQR);

    socketNFC.on('scannedPowerBingoPapir', handleScannedPowerBingoPapir);

    return () => {
      socketNFC.off('scannedXtippPapir', handleScannedXtippPapir);
      socketNFC.off('scannedKingoPapir', handleScannedKingoPapir);
      socketNFC.off('scannedPapir', handleScannedPowerBingoPapir);
      socketNFC.off('scannedQR', handleScannedQR);

      socketNFC.off('scannedPowerBingoPapir', handleScannedPowerBingoPapir);
    };
  }, [socketNFC]);

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        bgcolor: '#050505',
        color: 'text.primary',
      }}
    >
      {showModalSellKiosk && <ModalSellKiosk />}
      {showModalSellPapir && <ModalSellPapir />}
      {showModalSellPapirKingo && <ModalSellPapirKingo />}
      {showModalSellPapirXtipp && <ModalSellPapirXtipp />}
      {showModalConfirmLogout && <ModalConfirmationLogout />}
      {showModalPaymentKiosk && <ModalPayment />}
      {showModalBlockedToBuyDataBingo && <ModalBlockedToBuyDataBingo />}
      {showModalLimitSurpassedKiosk && <ModalLimitSurpassed />}
      {showModalPaperOutKiosk && <ModalPaperOutKiosk />}

      <Grid
        container
        sx={{
          height: '100%',
          maxWidth: 1080, // hard cap for kiosk width
          margin: '0 auto', // center if browser is wider
        }}
      >
        {/* Left: Vendors / content */}
        <Grid
          item
          xs={8}
          sx={{
            p: 2, // was 3
            display: 'flex',
            flexDirection: 'column',
            gap: 2.5, // slightly smaller
            backgroundColor: '#050505',
          }}
        >
          <Vendors />
        </Grid>

        {/* Right: Order column */}
        <Grid
          item
          xs={4}
          sx={{
            bgcolor: '#0c0c0c',
            borderLeft: '4px solid rgba(255,255,255,0.08)',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            p: 2,
          }}
        >
          <TransactionList />
        </Grid>
      </Grid>
    </Box>
  );
}

export default SalgsKiosk;
